import { Outlet } from 'react-router-dom';
import SiteHeader from './SiteHeader.jsx';
import SiteFooter from './SiteFooter.jsx';
import './site.css';

/** Shell for the public website pages. Signed-in app pages keep their own header and footer. */
export default function SiteLayout() {
  return <div className="mk-site">
    <SiteHeader/>
    <main id="main-content" className="mk-main" tabIndex={-1}><Outlet/></main>
    <SiteFooter/>
  </div>;
}
